// extracted by mini-css-extract-plugin
export var filterIncDec = "_9w-0";
export var leftBorder = "_9w-1";
export var rightBorder = "_9w-2";
export var stringInput = "_9w-3";